export default __webpack_public_path__ + "static/media/colissimo.652060db.png";